import { isNormalized01 } from "../model/surfDeck.js";
export function normToPx(rect, stage) {
    return {
        x: rect.x * stage.width,
        y: rect.y * stage.height,
        width: rect.w * stage.width,
        height: rect.h * stage.height,
    };
}
export function pxToNorm(x, y, width, height, stage) {
    if (stage.width <= 0 || stage.height <= 0) {
        throw new Error("Stage size invalid");
    }
    return clampNormRect({
        x: x / stage.width,
        y: y / stage.height,
        w: width / stage.width,
        h: height / stage.height,
    });
}
export const SURF_EDITOR_LAYER_MARGIN = 0.12;
export function clampNormRect(rect) {
    let { x, y, w, h } = rect;
    w = Math.max(0.02, Math.min(1, w));
    h = Math.max(0.02, Math.min(1, h));
    x = Math.max(0, Math.min(1 - w, x));
    y = Math.max(0, Math.min(1 - h, y));
    return { x, y, w, h };
}
/** Editor canvas — allows layers slightly outside the slide for handles and fine placement. */
export function clampNormRectEditor(rect, margin = SURF_EDITOR_LAYER_MARGIN) {
    let { x, y, w, h } = rect;
    w = Math.max(0.02, Math.min(1, w));
    h = Math.max(0.02, Math.min(1, h));
    x = Math.max(-margin, Math.min(1 + margin - w, x));
    y = Math.max(-margin, Math.min(1 + margin - h, y));
    return { x, y, w, h };
}
export function snapNormRectToSafeZone(rect, safe, threshold = 0.015) {
    let { x, y, w, h } = rect;
    const snap = (value, target) => Math.abs(value - target) <= threshold ? target : value;
    x = snap(x, safe.x);
    y = snap(y, safe.y);
    const right = snap(x + w, safe.x + safe.w);
    const bottom = snap(y + h, safe.y + safe.h);
    if (right !== x + w)
        x = right - w;
    if (bottom !== y + h)
        y = bottom - h;
    return clampNormRect({ x, y, w, h });
}
export function isValidNormRect(rect) {
    return (isNormalized01(rect.x) &&
        isNormalized01(rect.y) &&
        isNormalized01(rect.w) &&
        isNormalized01(rect.h) &&
        rect.x + rect.w <= 1 + 1e-9 &&
        rect.y + rect.h <= 1 + 1e-9);
}
